import { ReservedValues } from "@/constants/reservedValues";

export function normalizePortfolioPowerValue(value: unknown): number | null {
  return typeof value === "number" && Number.isFinite(value) && !ReservedValues.includes(value) ? value : null;
}
